<template>
  <div class="con-wrap full-page">
    <el-form
      size="medium"
      :inline="true"
      :model="queryForm"
      ref="queryForm"
      class="input-form-inline"
      @submit.native.prevent
    >
      <div>
        <el-form-item class="r-20" prop="reviewState">
          <el-select
            v-model="queryForm.reviewState"
            placeholder="请选择审核状态"
          >
            <el-option
              v-for="item in reviewState"
              :key="item.id"
              :label="item.label"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="r-20" prop="pushState">
          <el-select v-model="queryForm.pushState" placeholder="请选择推送状态">
            <el-option
              v-for="item in pushState"
              :key="item.id"
              :label="item.label"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-button
          v-if="hasPerm('news:push:list')"
          type="primary"
          @click="query"
          >查询</el-button
        >
        <el-button v-if="hasPerm('news:push:list')" @click="reset"
          >取消</el-button
        >
      </div>

      <div style="margin-bottom:20px">
        <el-button
          v-if="hasPerm('news:push:save')"
          type="primary"
          @click="addPush"
          >新增</el-button
        >
        <el-button
          v-if="hasPerm('news:push:update')"
          type="primary"
          @click="modifyPush"
          >修改</el-button
        >
        <el-button
          size="medium"
          v-if="hasPerm('news:push:delete')"
          type="danger"
          @click.native="delPush"
          >删除</el-button
        >
      </div>
    </el-form>
    <el-table
      ref="multipleTable"
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%"
      size="mini"
      stripe
      height="560px"
      @row-click="handleClickTableRow"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        type="selection"
        width="24"
        align="center"
        style="padding:0"
      ></el-table-column>
      <el-table-column type="index" label="序号" width="55"></el-table-column>
      <el-table-column prop="pushType" label="推送类型">
        <template slot-scope="scope">
          <span v-if="scope.row.pushType == 1">分组推送</span>
          <span v-else-if="scope.row.pushType == 2">单体推送</span>
        </template>
        <template slot="header">
          <span>推送类型</span>
          <span @click="pushTypeChange" class="iconfont icon-sort"></span>
        </template>
      </el-table-column>
      <el-table-column
        prop="title"
        label="消息标题"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column prop="userName" label="创建人员"></el-table-column>
      <el-table-column
        prop="addTime"
        label="创建时间"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column prop="reviewState" label="审核状态">
        <template slot-scope="scope">
          <span v-if="scope.row.reviewState == 1" class="btn-orange"
            >未审核</span
          >
          <span v-else-if="scope.row.reviewState == 2" class="btn-green"
            >审核通过</span
          >
          <span v-else-if="scope.row.reviewState == 3" class="btn-red"
            >审核拒绝</span
          >
          <span v-else></span>
        </template>
      </el-table-column>
      <el-table-column prop="reviewName" label="审核人员"></el-table-column>
      <el-table-column
        prop="reviewTime"
        label="审核时间"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column prop="pushState" label="推送状态">
        <template slot-scope="scope">
          <span v-if="scope.row.pushState == 1" class="btn-gray">未推送</span>
          <span v-else-if="scope.row.pushState == 2" class="btn-green"
            >已推送</span
          >
          <span v-else-if="scope.row.pushState == 3" class="btn-green"
            >推送成功</span
          >
          <span v-else-if="scope.row.pushState == 4" class="btn-red"
            >推送失败</span
          >
          <span v-else></span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="150" fixed="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="text"
            v-if="hasPerm('news:push:info:list')"
            @click.stop="getPushInfo(scope.row)"
            >详情</el-button
          >
          <span
            style="margin-left:10px"
            v-if="hasPerm('news:push:review,news:push:save:list')"
          >
            <el-button
              size="mini"
              type="text"
              v-if="scope.row.reviewState != 2"
              @click.stop="review(scope.row)"
            >
              <span>审核</span>
            </el-button>
            <span class="btn-gray phoney-btn" v-else>
              审核
            </span>
          </span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="currentPage"
      :page-size="limit"
      layout="total, prev, pager, next, jumper"
      :total="total"
    ></el-pagination>
    <!-- 新增推送 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="submitVisible"
      class="small-dialog"
    >
      <el-form :rules="rules" ref="PushForm" :model="PushForm" :inline="true">
        <el-form-item prop="pushType" label="推送类型">
          <el-select
            v-model="PushForm.pushType"
            placeholder="请选择推送类型"
            @change="typeChange"
          >
            <el-option
              v-for="item in pushTypeList"
              :key="item.id"
              :label="item.label"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="sysType" label="系统选择">
          <el-select v-model="PushForm.sysType" placeholder="请选择系统类型">
            <el-option
              v-for="item in sysTypes"
              :key="item.id"
              :label="item.label"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="icons-wrap" prop="user" label="创建人">
          <i class="icons"></i>
          <el-input
            v-model="user"
            placeholder="请输入创建人"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item prop="appId" label="应用名称">
          <el-select v-model="PushForm.appId" placeholder="请选择应用名称">
            <el-option
              v-for="item in appNameList"
              :key="item.appId"
              :label="item.name"
              :value="item.appId"
            ></el-option>
          </el-select>
        </el-form-item>
        <div>
          <el-form-item prop="title" label="信息标题">
            <el-input
              v-model="PushForm.title"
              placeholder="请输入信息标题"
            ></el-input>
          </el-form-item>
        </div>
        <el-form-item class="long-input" prop="content" label="信息内容">
          <el-input
            type="textarea"
            v-model="PushForm.content"
            placeholder="请输入信息内容"
          ></el-input>
        </el-form-item>
      </el-form>
      <group-tree
        v-if="PushForm.pushType == 1"
        :deptList="deptList"
        :tabName="activeName"
        :selectedTree="selectedTree"
        @treeClick="treeSelectClick"
      ></group-tree>
      <div v-if="PushForm.pushType == 2">
        <el-form
          size="medium"
          :inline="true"
          :model="dialogQueryForm"
          ref="dialogQueryForm"
          @submit.native.prevent
        >
          <el-form-item class="r-20" prop="deviceId">
            <el-input
              v-model="dialogQueryForm.deviceId"
              @keyup.enter.native="dialogQuery"
              placeholder="设备编号"
            ></el-input>
          </el-form-item>
          <el-button
            v-if="hasPerm('news:push:info:list')"
            type="primary"
            @click="dialogQuery"
            >查询</el-button
          >
          <el-button v-if="hasPerm('news:push:info:list')" @click="dialogReset"
            >取消</el-button
          >
        </el-form>
        <el-table
          ref="dialogTable"
          :data="dialogTableData"
          tooltip-effect="dark"
          style="width: 100%;"
          size="mini"
          stripe
          height="300px"
          @row-click="dialogClickTableRow"
          @selection-change="dialogSelectionChange"
          :row-key="getRowKeys"
        >
          <el-table-column
            type="selection"
            width="24"
            align="center"
            style="padding:0"
            :reserve-selection="true"
          ></el-table-column>
          <el-table-column
            type="index"
            label="序号"
            width="55"
          ></el-table-column>
          <el-table-column prop="vin" label="车架号"></el-table-column>
          <el-table-column prop="deviceId" label="设备编号"></el-table-column>
          <el-table-column prop="name" label="车辆绑定人"></el-table-column>
          <el-table-column prop="phone" label="联系电话"></el-table-column>
        </el-table>
        <el-pagination
          @size-change="dialogSizeChange"
          @current-change="dialogCurrentChange"
          :current-page.sync="dialogCurrentPage"
          :page-size="dialogLimit"
          layout="total, prev, pager, next, jumper"
          :total="dialogTotal"
        ></el-pagination>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="submitVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveOrUpdate">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 详情和审核弹窗 -->
    <el-dialog
      :title="infoTitle"
      :visible.sync="infoVisible"
      class="mini-dialog info-box"
      width="46%"
    >
      <info-box
        :infoData="infoData"
        :tableDataArr="tableDataArr"
        :total="infoTotal"
        @currentChange="infoList"
      ></info-box>
      <span v-if="reviewPushId != ''" slot="footer" class="dialog-footer">
        <el-button type="success" @click="reviewBtn(2)">通过</el-button>
        <el-button type="danger" @click="reviewBtn(3)">未通过</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import GroupTree from "./components/GroupTree.vue"
import InfoBox from "./components/InfoBox.vue"
export default {
  components: {
    GroupTree,
    InfoBox,
  },
  data() {
    return {
      queryForm: {
        pushState: "",
        reviewState: "",
      },
      pushType: "",
      currentPage: 1,
      limit: 10,
      total: 0,
      tableData: [],
      tableVal: [],
      reviewState: [
        {
          id: 1,
          label: "未审核",
        },
        {
          id: 2,
          label: "审核通过",
        },
        {
          id: 3,
          label: "审核拒绝",
        },
      ],
      pushState: [
        {
          id: 1,
          label: "未推送",
        },
        {
          id: 2,
          label: "已推送",
        },
        {
          id: 3,
          label: "推送成功",
        },
        {
          id: 4,
          label: "推送失败",
        },
      ],
      dialogTitle: "新增推送消息",
      submitVisible: false,
      rules: {
        pushType: [
          {
            required: true,
            trigger: "change",
            message: "请选择推送类型",
          },
        ],
        sysType: [
          {
            required: true,
            trigger: "change",
            message: "请输入系统类型",
          },
        ],
        appId: [
          {
            required: true,
            trigger: "change",
            message: "请选择应用名称",
          },
        ],
        title: [
          {
            required: true,
            trigger: "change",
            message: "请输入信息标题",
          },
        ],
        content: [
          {
            required: true,
            trigger: "change",
            message: "请输入信息内容",
          },
        ],
      },
      pushTypeList: [
        {
          id: 1,
          label: "分组推送",
        },
        {
          id: 2,
          label: "单体推送",
        },
      ],
      sysTypes: [
        {
          id: 1,
          label: "android",
        },
        {
          id: 2,
          label: "ios",
        },
      ],
      PushForm: {
        appId: "",
        content: "",
        pushId: "",
        pushType: "",
        subjects: [],
        sysType: "",
        title: "",
      },
      user: "",
      appNameList: [],
      dialogQueryForm: {},
      dialogLimit: 10,
      dialogCurrentPage: 1,
      dialogTotal: 0,
      dialogTableData: [],
      // 修改时默认选中列表的数据
      hasSelectList: [],
      dialogTableVal: [],
      deptList: [],
      activeName: "",
      editTag: "0",
      treeSelected: [],
      selectedTree: [],
      changeModify: "0",
      infoVisible: false,
      infoTitle: "",
      infoData: {},
      tableDataArr: [],
      infoTotal: 0,
      reviewPushId: "",
    }
  },
  created() {
    this.getPushList()
    this.getAppList()
  },
  mounted() {
    this.user = sessionStorage.getItem("user")
  },
  methods: {
    async getPushList() {
      let obj = {
        limit: this.limit,
        page: this.currentPage,
        pushState: this.queryForm.pushState,
        reviewState: this.queryForm.reviewState,
        pushType: this.pushType,
      }
      let _this = this
      let { data: res } = await _this.$axios.get("/api/news/push/list", {
        params: obj,
      })
      if (res.code == 1) {
        _this.tableData = res.data.list
        _this.total = res.data.totalCount
      }
    },
    query() {
      this.getPushList()
    },
    reset() {
      this.$resetForm(this, "queryForm")
      this.pushType = ""
      this.getPushList()
    },
    pushTypeChange() {
      this.pushType = this.pushType == 1 ? 2 : 1
      this.getPushList()
    },
    addPush() {
      this.changeModify = "0"
      this.editTag = "0"
      this.getPushSaveList()
      this.dialogTitle = "新增推送消息"
      this.$resetForm(this, "PushForm")
      this.submitVisible = true
    },
    modifyPush() {
      this.changeModify = "0"
      if (this.tableVal.length > 1) {
        this.$message.warning("一次只能修改一条数据")
        return
      }
      let id = this.$getIds(this.tableVal)
      if (!id) {
        return
      }
      this.editTag = "1"
      this.dialogTitle = "修改推送消息"
      this.$resetForm(this, "PushForm")
      this.submitVisible = true
      this.getModifyInfo(id)
    },
    async getModifyInfo(id) {
      let _this = this
      let { data: res } = await _this.$axios.get("/api/news/push/info/" + id)
      if (res.code == 1) {
        _this.PushForm = res.data
        if (_this.PushForm.pushType == "1") {
          _this.getdeptList()
          _this.activeName = _this.PushForm.parentDeptId + ""
          _this.selectedTree = _this.PushForm.subjects
        } else if (_this.PushForm.pushType == "2") {
          _this.hasSelectList = _this.PushForm.subjects
          _this.getPushSaveList()
        }

        //详情数据赋值
        // _this.deviceInfo = res.data
        // if (_this.deviceInfo.active == 1) {
        //   _this.deviceInfo.active = "未激活"
        // }
      } else {
        _this.$message.warning(res.msg)
      }
    },
    async delPush() {
      let _this = this
      //多选删除
      let ids = _this.$getIds(_this.tableVal)
      if (!ids) {
        return
      }
      _this
        .$confirm("确定删除吗？", "系统提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(async () => {
          let { data: res } = await _this.$axios.delete("/api/news/push", {
            data: JSON.stringify(ids),
          })
          if (res.code == 1) {
            _this.$message.success("操作成功")
            let totalPage = Math.ceil((_this.total - 1) / 10)
            let currentPage =
              _this.currentPage > totalPage ? totalPage : _this.currentPage
            _this.currentPage = currentPage < 1 ? 1 : currentPage
            _this.getPushList()
          } else {
            _this.$message.warning(res.msg)
          }
        })
    },
    //详情
    getPushInfo(rowData) {
      this.infoVisible = true
      this.infoTitle = "推送消息详情"
      this.reviewPushId = ""
      this.baseInfo(rowData.id)
      this.infoList(rowData.id, rowData.pushType, 1)
    },
    //审核
    review(rowData) {
      this.infoVisible = true
      this.infoTitle = "推送消息审核"
      this.reviewPushId = rowData.id
      this.baseInfo(rowData.id)
      this.infoList(rowData.id, rowData.pushType, 1)
    },
    async reviewBtn(review) {
      let _this = this
      let { data: res } = await _this.$axios.patch(
        "/api/news/push/review?pushId=" +
          this.reviewPushId +
          "&review=" +
          review
      )
      if (res.code == 1) {
        _this.getPushList()
        _this.infoVisible = false
        _this.$message.success("操作成功")
      } else {
        _this.$message.warning(res.msg)
      }
    },
    async baseInfo(id) {
      let _this = this
      let { data: res } = await _this.$axios.get("/api/news/push/info/" + id)
      if (res.code == 1) {
        //详情数据赋值
        _this.infoData = res.data
        if (_this.infoData.pushType == 1) {
          _this.infoData.pushType = "分组推送"
        } else if (_this.infoData.pushType == 2) {
          _this.infoData.pushType = "单体推送"
        }
      } else {
        _this.$message.warning(res.msg)
      }
    },
    async infoList(id, type, page) {
      let obj = {
        limit: 10,
        page: page,
        pushId: id,
        pushType: type,
      }
      let _this = this
      let { data: res } = await _this.$axios.get("/api/news/push/info/list", {
        params: obj,
      })
      if (res.code == 1) {
        _this.tableDataArr = res.data.list
        _this.infoTotal = res.data.totalCount
      }
    },
    async getAppList() {
      let _this = this
      let { data: res } = await _this.$axios.get("/api/news/push/app/options")
      if (res.code == 1) {
        _this.appNameList = res.data
      } else {
        _this.$message.warning(res.msg)
      }
    },
    dialogQuery() {
      this.getPushSaveList()
    },
    dialogReset() {
      this.$resetForm(this, "dialogQueryForm")
      this.getPushSaveList()
    },
    async getPushSaveList() {
      let obj = {
        limit: this.dialogLimit,
        page: this.dialogCurrentPage,
        deviceId: this.dialogQueryForm.deviceId,
      }
      let _this = this
      let { data: res } = await _this.$axios.get("/api/news/push/save/list", {
        params: obj,
      })
      if (res.code == 1) {
        _this.dialogTableData = res.data.list
        _this.dialogTotal = res.data.totalCount
        // 修改时单体推送时默认选中列表
        if (_this.editTag == "1") {
          _this.$nextTick(() => {
            _this.dialogTableData.forEach((row) => {
              if (_this.hasSelectList.indexOf(row.id) >= 0) {
                _this.$refs.dialogTable.toggleRowSelection(row, true)
              }
            })
          })
        }
      }
    },
    typeChange() {
      let _this = this
      this.hasSelectList = []
      this.selectedTree = []
      if (_this.PushForm.pushType == "2") {
        _this.getPushSaveList()
      } else if (_this.PushForm.pushType == "1") {
        this.changeModify = "1"
        _this.getdeptList()
      }
    },
    async getdeptList() {
      let _this = this
      let { data: res } = await _this.$axios.get("/api/news/push/dept")
      if (res.code == 1) {
        _this.deptList = res.data
        if (_this.editTag == "0" || _this.changeModify == "1") {
          _this.activeName = _this.deptList[0].id + ""
        }
        for (var i = 0; i < _this.deptList.length; i++) {
          _this.deptList[i].id += ""
          console.log(_this.deptList[i].id)
        }
      } else {
        _this.$message.warning(res.msg)
      }
    },
    treeSelectClick(treeArr) {
      this.treeSelected = treeArr
    },
    saveOrUpdate() {
      let _this = this
      let data = []
      _this.$refs.PushForm.validate(async (valid) => {
        if (valid) {
          if (_this.PushForm.pushType == "2") {
            let ids = _this.$getIds(_this.dialogTableVal)
            _this.PushForm.subjects = ids
          } else if (_this.PushForm.pushType == "1") {
            _this.PushForm.subjects = _this.treeSelected
          }
          if (_this.PushForm.subjects.length == 0) {
            _this.$message.warning("请先选择推送对象")
            return
          }
          if (_this.editTag == "0") {
            data = await _this.$axios.post("/api/news/push", _this.PushForm)
          } else {
            data = await _this.$axios.patch("/api/news/push", _this.PushForm)
          }
          let res = data.data
          if (res.code == 1) {
            //信息提示
            _this.$message.success("操作成功")
            //刷新推送列表
            _this.getPushList()
            _this.submitVisible = false
          } else {
            _this.$message.warning(res.msg)
          }
        }
      })
    },
    //选择数据变化监控
    handleSelectionChange(val) {
      this.tableVal = val
    },
    handleClickTableRow(row, event, column) {
      console.log(row)
      console.log(column)
      this.$refs.multipleTable.toggleRowSelection(row)
    },
    //pagesize改变时触发
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
    },
    //页数改变时触发
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`)
      this.currentPage = val
      this.getPushList()
    },
    //新增模态框中分页表格
    //选择数据变化监控
    dialogSelectionChange(val) {
      this.dialogTableVal = val
    },
    dialogClickTableRow(row, event, column) {
      console.log(row)
      console.log(column)
      this.$refs.dialogTable.toggleRowSelection(row)
    },
    getRowKeys(row) {
      return row.id
    },
    //pagesize改变时触发
    dialogSizeChange(val) {
      console.log(`每页 ${val} 条`)
    },
    //页数改变时触发
    dialogCurrentChange(val) {
      console.log(`当前页: ${val}`)
      this.dialogCurrentPage = val
      this.getPushSaveList()
    },
  },
}
</script>

<style lang="scss" scoped>
.full-page {
  padding: 0 20px;
  background: #fff;
}
.phoney-btn {
  display: inline-block;
}
.small-dialog /deep/ .el-dialog {
  width: 900px;
}
.small-dialog /deep/ .el-form-item__content,
.el-date-editor.el-input {
  width: 270px;
  height: 32px;
}
.long-input /deep/ .el-form-item__content {
  width: 690px !important;
  height: auto;
}
.small-dialog /deep/ .el-form-item__label {
  width: 140px;
  height: 32px;
  padding-left: 30px;
  text-align: left;
  font-size: 14px;
  color: #333;
}
.small-dialog /deep/ .el-pagination {
  padding-top: 10px;
}
.icons-wrap {
  position: relative;
}
.icons-wrap /deep/ .el-form-item__label {
  padding-left: 41px;
}
.icons-wrap /deep/ .icons::before {
  content: "*";
  color: #f56c6c;
  position: absolute;
  left: -111px;
}
</style>
